import React from 'react';
import { LineChart, BarChart, CheckCircleIcon } from 'lucide-react';
import Button from './Button';
const SolutionSection = () => {
  return <div className="w-full bg-gray-100 text-gray-800 py-16 px-4" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-700" data-id="element-131">
          Dlaczego WSZYSTKIE dotychczasowe rady cię zawiodły
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-md my-8 border-l-4 border-blue-500" data-id="element-132">
          <p className="text-lg italic" data-id="element-133">
            "Problem nie polega na tym, że te kobiety nie mają czasu. Problem
            polega na tym, że straciły kontakt z własną tożsamością. Nie wiedzą
            już, czego chcą, bo przez lata słuchały tylko tego, czego chcą
            inni."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-134">
          Dr Radecka odkryła coś, czego żaden ekspert wcześniej nie badał tak
          głęboko:
        </p>
        <div className="bg-white p-6 rounded-lg shadow-md my-8 border-l-4 border-blue-500" data-id="element-135">
          <p className="text-lg italic" data-id="element-136">
            "Wszystkie tradycyjne metody 'dbania o siebie' zawodzą kobiety z
            pokolenia kanapkowego z jednego kluczowego powodu – zakładają, że te
            kobiety nadal wiedzą, kim są. Tymczasem one już tego nie pamiętają."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-137">Jej badania pokazały, że:</p>
        <ul className="mb-8 space-y-4" data-id="element-138">
          <li className="flex items-start" data-id="element-139">
            <span className="text-red-500 mr-2" data-id="element-140">✗</span>
            <span className="text-lg" data-id="element-141">
              Kursy mindfulness nie działają, bo mówią "obserwuj swoje myśli",
              ale te kobiety mają tylko myśli o obowiązkach
            </span>
          </li>
          <li className="flex items-start" data-id="element-142">
            <span className="text-red-500 mr-2" data-id="element-143">✗</span>
            <span className="text-lg" data-id="element-144">
              Planery i organizery nie działają, bo dodają kolejne zadania do
              już przepełnionej listy
            </span>
          </li>
          <li className="flex items-start" data-id="element-145">
            <span className="text-red-500 mr-2" data-id="element-146">✗</span>
            <span className="text-lg" data-id="element-147">
              Porady typu 'znajdź czas dla siebie' nie działają, bo te kobiety
              nie wiedzą już, co to znaczy "dla siebie"
            </span>
          </li>
          <li className="flex items-start" data-id="element-148">
            <span className="text-red-500 mr-2" data-id="element-149">✗</span>
            <span className="text-lg" data-id="element-150">
              Terapia klasyczna często nie działa, bo skupia się na
              rozwiązywaniu problemów, a nie na odbudowywaniu tożsamości
            </span>
          </li>
        </ul>
        <div className="bg-white p-6 rounded-lg shadow-md my-8" data-id="element-151">
          <p className="text-lg italic" data-id="element-152">
            "To jak mówienie osobie, która zapomniała własnego języka, żeby po
            prostu zaczęła mówić" – wyjaśniała dr Radecka.
          </p>
        </div>
        <div className="w-full h-px bg-gray-300 my-10" data-id="element-153"></div>
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-700 text-center" data-id="element-154">
          Przełomowe odkrycie: dlaczego 15 minut zmienia wszystko
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-md my-8 border-l-4 border-green-500" data-id="element-155">
          <p className="text-lg italic" data-id="element-156">
            "Tożsamość nie odbudowuje się przez wielkie gesty czy radykalne
            zmiany. Odbudowuje się przez mikrorytuały przypominania sobie, kim
            się jest."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-157">
          Jej zespół badawczy odkrył, że kobiety, które codziennie poświęcały
          zaledwie 15 minut na "mikropraktyki odzyskiwania tożsamości", po 3
          tygodniach wykazywały:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-8" data-id="element-158">
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-159">
            <div className="flex justify-center mb-4" data-id="element-160">
              <LineChart size={40} className="text-green-500" data-id="element-161" />
            </div>
            <p className="text-3xl font-bold text-green-500 mb-2" data-id="element-162">78%</p>
            <p className="text-lg" data-id="element-163">poprawę w poczuciu własnej wartości</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-164">
            <div className="flex justify-center mb-4" data-id="element-165">
              <BarChart size={40} className="text-green-500" data-id="element-166" />
            </div>
            <p className="text-3xl font-bold text-green-500 mb-2" data-id="element-167">65%</p>
            <p className="text-lg" data-id="element-168">redukcję objawów wypalenia emocjonalnego</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-169">
            <div className="flex justify-center mb-4" data-id="element-170">
              <CheckCircleIcon size={40} className="text-green-500" data-id="element-171" />
            </div>
            <p className="text-3xl font-bold text-green-500 mb-2" data-id="element-172">82%</p>
            <p className="text-lg" data-id="element-173">
              wzrost jasności co do własnych potrzeb i pragnień
            </p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md my-8 border-l-4 border-green-500" data-id="element-174">
          <p className="text-lg italic" data-id="element-175">
            "Te 15 minut to nie czas na produktywność czy relaks. To czas na
            przypominanie sobie, kim jesteś poza rolami, które pełnisz" –
            podkreślała.
          </p>
        </div>
        <p className="text-lg mb-6 font-bold" data-id="element-176">Ale najważniejsze było to:</p>
        <div className="bg-white p-6 rounded-lg shadow-md my-8 border-l-4 border-green-500" data-id="element-177">
          <p className="text-lg italic" data-id="element-178">
            "Nie chodzi o dodanie kolejnej rzeczy do twojej listy. Chodzi o
            odjęcie – odjęcie wszystkich ról, oczekiwań i obowiązków. Zostaje
            tylko ty."
          </p>
        </div>
        <div className="my-12 bg-amber-50 p-6 rounded-lg border-l-4 border-amber-400" data-id="element-179">
          <p className="text-xl mb-6 font-bold text-center" data-id="element-180">
            Czy rozpoznajesz siebie w tych słowach?
          </p>
          <p className="text-lg mb-6" data-id="element-181">
            Jeśli tak, to właśnie dla ciebie powstał e-book "Nie zapomnij o
            sobie" - praktyczny przewodnik oparty na metodzie dr Radeckiej.
          </p>
          <div className="mt-8 flex justify-center" data-id="element-182">
            <Button data-id="element-183" />
          </div>
        </div>
        <p className="text-lg mb-6" data-id="element-184">
          Szukałam więcej, ale wszędzie były tylko strzępki informacji.
          Desperacko szukałam więcej informacji o tej metodzie. Znajdowałam
          tylko fragmenty w artykułach naukowych, strzępki wywiadów. Metoda dr
          Radeckiej nie była nigdzie opisana w całości.
        </p>
        <p className="text-lg mb-6" data-id="element-185">
          Frustracja rosła. Miałam klucz do rozwiązania, ale tylko jego kawałek.
        </p>
        <p className="text-lg mb-6 font-bold" data-id="element-186">
          Aż pewnej nocy, błądząc po forach dla kobiet w podobnej sytuacji,
          trafiłam na post, który zmienił moje życie.
        </p>
      </div>
    </div>;
};
export default SolutionSection;